import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ProgressSpinner } from "primereact/progressspinner";
import { getWareHouseStoreChallanQrCode } from "../../services/ChallanApi/Challan";
import { getReadyGarmentToSendToStore } from "../../services/warehouse/WarehouseProcess";

import addItemSound from '../../assets/sounds/warehousesound3.mp3';
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
const ReceiveFromStore = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { data } = location.state || {}; // Fallback to prevent undefined errors

  const { warehouseData, brandProfileData } = getUserData();

  let warehouseId = warehouseData.id;
  let enabledRfIdModal = brandProfileData.enabledRfIdModal;

  
  const audioRef = useRef(new Audio(addItemSound));
  const handleAddItem = () => {
    const audio = audioRef.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState(null);
   const [searchMethod, setSearchMethod] = useState(true);
    const [qrMethod, setQrMethod] = useState(false);
    const [rfidMethod, setRfidMethod] = useState(false);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [searchByInvoiceMethod, setSearchByInvoiceMethod] = useState(false);
  const [changeScannerMethod, setChangeScannerMethod] = useState(false);
  const [modalText, setModalText] = useState("");
  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseValue, setWarehouseValue] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);
  const getInvoiceNo = (qrCode) => qrCode.split("OI")[0];

  const [changeQrMethod, setChangeQrMethod] = useState(false);
  const [searchTermFocus, setSearchTermFocus] = useState("");
  const inputRef = useRef(null);

  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);

//   let qrCodeMap = new Map();
//   const fetchData = (data) => {
//     getStoreWarehouseQrCodeByStatus(warehouseId, data)
//       .then((response) => {
//         if (!response.data.error) {
//           response.data.forEach((element) => {
//             qrCodeMap.set(element.qrcode, element.garment);
//           });
//           setQrCodes(qrCodeMap);
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         console.error("Error:", err);
//       });
//     getStoreWarehouseInfo(warehouseId)
//       .then((response) => {
//         if (!response.data.error) {
//           const Res = response.data;
//           const warehouseData = response.data.map((item) => ({
//             code: item.id,
//             name: item.wareHouse.name,
//           }));
//           setWarehouseList(warehouseData);
//           if (warehouseData.length === 1)
//             setWarehouseValue(warehouseData[0].id);
//         }
//       })
//       .catch((err) => {
//         console.error("Error:", err);
//       });
//   };

//   useEffect(() => {
//     const data = {
//       status: ["IN_PROCESS"],
//     };
//     fetchData(data);
//   }, []);


  let qrCodeMap = new Map();
  const fetchChallanQrCodeList = data => {
    getWareHouseStoreChallanQrCode(data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          //  setChallanQrCodeData(Res);
          const QrCodeStatusData = response.data.filter(
            item => item.qrCodeInfo.status === 'SENT_TO_WARE_HOUSE',
          );
          QrCodeStatusData.forEach(element => {
            let garmentInfo = {
              garmentName: element.qrCodeInfo.garmentName,
              storeCode: element.qrCodeInfo.storeCode,
              id: element.qrCodeInfo.id,
              rfid: element.qrCodeInfo.rfid,
              createdDate: element.qrCodeInfo.createdDate,
            };
            qrCodeMap.set(element.qrCodeInfo.qrCode, garmentInfo);
          });
          setQrCodes(qrCodeMap);
          setLoading(false);        
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };


  useEffect(() => {
    if (data) {
      const requestData = {
        startDate: localeDateStartDate(new Date(data.createdDate)),
        endDate: localeDateEndDate(new Date(data.createdDate)),
        wareHouseStoreIdIn: [data.wareHouseStoreId],
        challanTypeStatusIn: [data.challanTypeStatus],
        challanIdIn: [data.id],
        qrCodeStatusIn: [],
        recordType: '',
      };


      fetchChallanQrCodeList(requestData);
    }
  }, [data]);

  
  
  const groupByInvoice = (data) => {
    const groups = {};

    data.forEach((item) => {
      const invoice = getInvoiceNo(item.qrCode);

      if (!groups[invoice]) groups[invoice] = [];
      groups[invoice].push(item);
    });

    return groups;
  };

  const handleScanAll = (items) => {
    const allItems = items.map((item) => ({
      garment: item.garment.garmentName,
      storeCode: item.garment.storeCode,
      id: item.garment.id,
      rfid: item.garment.rfid,
      createdDate: item.garment.createdDate,
      qrCode: item.qrCode,
    }));
    

    const newQrCodes = allItems.filter(
      (obj) => !selectedQrCodesChecked.includes(obj.qrCode)
    );

    setSelectedQrCodes((prev) => [...prev, ...newQrCodes]);
    setDataProvider((prev) => [...prev, ...newQrCodes]);
    setSelectedQrCodesChecked((prev) => [
      ...prev,
      ...newQrCodes.map((i) => i.qrCode),
    ]);

    handleAddItem();
  };


  const handleClearSearch = () => {
    setSearchTermFocus("");
    setAlreadyPresentData("");
  };

  const [alreadyPresentData, setAlreadyPresentData] = useState("");

  const refocusInput = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Refocus the input
      }
    }, 10); // Add slight delay to ensure it focuses after processing
  };

  const handleScan = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");
      // Ensure data exists
      if (qrCodes.has(data)) {
        setSearchTermFocus("");
        if (!selectedQrCodesChecked.includes(data)) {
          let scannedData = {
            garment: qrCodes.get(data).garmentName,
            storeCode: qrCodes.get(data).storeCode,
            id: qrCodes.get(data).id,
            rfid: qrCodes.get(data).rfid,
            createdDate: qrCodes.get(data).createdDate,
            qrCode: data,
          };
          setSelectedQrCodes([...selectedQrCodes, scannedData]);
          setDataProvider([...selectedQrCodes, scannedData]);
          handleAddItem()
          setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

  const handleScanRFID = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");

      // Check if RFID is already scanned before doing anything
      if (selectedQrCodesChecked.includes(data)) {
        setAlreadyPresentData(`Tag ${data} already exists.`);
        refocusInput();
        setSearchTermFocus("");
        return; // Stop further processing
      }

      // Find the entry in the map where the RFID matches the scanned value
      const garmentEntry = [...qrCodes.entries()].find(
        ([_, value]) => value.rfid === data
      );

      if (garmentEntry) {
        const [qrCode, garmentInfo] = garmentEntry;

        // Check if it’s already selected
        if (!selectedQrCodesChecked.includes(qrCode)) {
          let scannedData = {
            garment: garmentInfo.garmentName,
            storeCode: garmentInfo.storeCode,
            id: garmentInfo.id,
            rfid: garmentInfo.rfid,
            createdDate: garmentInfo.createdDate,
            qrCode,
          };
          setSelectedQrCodes([...selectedQrCodes, scannedData]);
          setDataProvider([...selectedQrCodes, scannedData]);
          handleAddItem();
          setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      } else {
        console.warn(`Scanned RFID ${data} not found in QR code map.`);
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

  const handleWarehouseChange = (selectedItem) => {
    setWarehouseValue(selectedItem);
  };

  useEffect(() => {
    if (!searchTerm) {
      setDataProviderSuggestion([]);
    } else {
      const suggestions = [];
      qrCodes.forEach((garment, qrCode, storeCode) => {
        if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
          suggestions.push({ qrCode, garment, storeCode });
        }
      });

      setDataProviderSuggestion(suggestions);
    }
  }, [searchTerm]);

  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes.forEach((garment, qrCode, storeCode) => {
      if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({ qrCode, garment, storeCode });
      }
    });

    const newQrCodes = suggestions.filter(
      (item) => !selectedQrCodesChecked.includes(item.qrCode)
    );

    const updatedSelectedQrCodes = [
      ...selectedQrCodes,
      ...newQrCodes.map((item) => ({
        garment: item.garment.garmentName,
        storeCode: item.garment.storeCode,
        id: item.garment.id,
        rfid: item.garment.rfid,
        createdDate: item.garment.createdDate,
        qrCode: item.qrCode,
      })),
    ];

    setSelectedQrCodes(updatedSelectedQrCodes);
    setDataProvider(updatedSelectedQrCodes);

    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map((item) => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
  };

  const removeTag = (data) => {
    const updatedTag = selectedQrCodes.filter(
      (item) => item.qrCode !== data.qrCode
    );
    setSelectedQrCodes(updatedTag);
    setDataProvider(updatedTag);
    setSelectedQrCodesChecked(
      selectedQrCodesChecked.filter((code) => code !== data.qrCode)
    );
  };

  const handleRemoveAllSelectedData = () => {
    // Clear all selected QR codes and checked items
    setSelectedQrCodes([]);
    setSearchTerm("");
    setWarehouseValue("");
    setSelectedQrCodesChecked([]);

    // Reset the dataProvider to an empty state
    setDataProvider([]);

    // Optionally, reset the suggestions dataProvider
    setDataProviderSuggestion([]);
  };

  const handleSendToWarehouse = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      const data = {
        qrCodeIdList: selectedQrCodes.map(qr => qr.id),
        status: 'IN_PROCESS',
      };
      getReadyGarmentToSendToStore(warehouseId, data) // warehouseId
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;


            const message = Res.message;
            const success = Res.status;
            if (success === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
              setTimeout(() => {
                navigate('/Orders');
              }, 1500);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            }
          }
        })
        .catch(err => {
          console.error('Error:', err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
        <p className="flex-1 text-lg font-normal ">
          {(item.garment.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garment + "").length > 20 ? "..." : ""}
        </p>
        <p className="flex-1 text-lg font-normal capitalize">
          {(item.storeCode?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.storeCode + "").length > 20 ? "..." : ""}
        </p>
        <div
          onClick={() => removeTag(item)}
          className="flex-1 text-lg font-normal text-right cursor-pointer"
        >
          <img
            src={
              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
            }
            style={{ width: "10%" }}
          />
        </div>
      </div>
    ));
  };

  const renderSearchedByInvoiceTagItem = () => {
    if (!qrCodes || qrCodes?.length === 0) return null;

    // --- FILTER BY TODAY ---
    const today = new Date().toISOString().split("T")[0];

    const suggestions = [];
    qrCodes?.forEach((garment, qrCode) => {
      // if (today === garment.createdDate?.split("T")[0]) {
        suggestions.push({ qrCode, garment });
      // }
    });

    if (suggestions.length === 0) return <div>No data for today</div>;

    // Group the filtered data
    const groupedData = groupByInvoice(suggestions);

    return (
      <>
        {Object.keys(groupedData).map((invoiceNo) => (
          <div key={invoiceNo} className="mb-2 border-b pb-2">
            <div className="flex justify-content-between items-center bg-gray-100 px-2 py-2">
              <div className="text-xl font-bold">{invoiceNo}</div>

              <div
                onClick={() => handleScanAll(groupedData[invoiceNo])}
                className="cursor-pointer text-right"
              >
                <img
                  src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                  style={{ width: "40%" }}
                />
              </div>
            </div>

            {/*groupedData[invoiceNo].map((item, index) => {
            const isSelected = selectedQrCodesChecked.includes(item.qrCode);

            return (
              <div
                key={index}
                onClick={() => handleScan({ data: item.qrCode })}
                className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
              >
                <p className="flex-1 text-lg">{item.qrCode}</p>

                <p className="flex-1 text-lg">
                  {item.garment.garment.replace(/_/g, " ").substring(0, 20)}
                  {item.garment.garment.length > 20 ? "..." : ""}
                </p>

                <div className="flex-1 text-right">
                  {isSelected ? (
                    <img
                      src="Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      style={{ width: "10%" }}
                    />
                  ) : (
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                      style={{ width: "10%" }}
                    />
                  )}
                </div>
              </div>
            );
          })*/}
          </div>
        ))}
      </>
    );
  };

  const renderSearchedTagItem = () => {
    return dataProviderSuggestion?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrCode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrCode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
          <p className="flex-1 text-lg font-normal ">
            {(item.garment.garmentName.replace(/_/g, " ") + "").substring(
              0,
              20
            )}
            {(item.garment.garmentName + "").length > 20 ? "..." : ""}
          </p>
          <p className="flex-1 text-lg font-normal capitalize">
            {(item.garment.storeCode?.replace(/_/g, " ") + "").substring(0, 20)}
            {(item.garment.storeCode + "").length > 20 ? "..." : ""}
          </p>

          <div className="flex-1 text-lg font-normal text-right">
            <div>
              {isSelected ? (
                <img
                  src={
                    "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                  }
                  style={{ width: "10%" }}
                />
              ) : (
                <img
                  src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                  style={{ width: "10%" }}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  const handleBackButton = () => {
    navigate("/WarehouseChallanList");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div onClick={() => refocusInput()}>
                <p> </p>
              </div>
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Receive From Store
              </p>
            </div>
            {qrCodes?.size > 0 && (
              <div
                className="flex justify-content-center align-items-center mr-3"
                style={{
                  // left: 28,
                  // position: "absolute",
                  // top: -10,
                  backgroundColor: "red",
                  borderRadius: 20,
                  minWidth: 36,
                  height: 36,
                }}
              >
                <p className=" text-lg text-white font-normal text-center">
                  {qrCodes?.size}
                </p>
              </div>
            )}
            <div
              onClick={() => {
                setSearchByInvoiceMethod(true);
                setSearchMethod(false);
                setQrMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  marginRight: 30,
                }}
              >
                <img
                  src={"Img/searchInvoice.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            <div
              onClick={() => {
                setSearchMethod(true);
                setQrMethod(false);
                setRfidMethod(false);
                setSearchByInvoiceMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,

                  marginRight: 30,
                }}
              >
                <i
                  className="pi pi-search"
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div
              onClick={() => {
                setQrMethod(true);
                setSearchMethod(false);
                setRfidMethod(false);
                setSearchByInvoiceMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center border-1 cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  backgroundColor: "#fff",

                  marginRight: 30,
                  borderColor: "#fff",
                }}
              >
                <img
                  src={"images/qr-code.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            {enabledRfIdModal && (
              <div
                onClick={() => {
                  setRfidMethod(true);
                  setQrMethod(false);
                  setSearchMethod(false);
                  refocusInput();
                  setSearchByInvoiceMethod(false);
                  setSearchTerm("");
                  setSearchTermFocus("");
                }}
                className="cursor-pointer"
              >
                <div
                  className="flex justify-content-center align-items-center cursor-pointer"
                  style={{
                    height: 32,
                    width: 32,
                    marginRight: 30,
                  }}
                >
                  <img
                    src={"images/rfid-tags.png"}
                    style={{ height: 38, width: 38 }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex-1 flex flex-column justify-content-center align-items-center">
          <ProgressSpinner />

          <p
            style={{
              color: "#000",
              fontSize: 20,
              fontWeight: "700",
              alignSelf: "center",
            }}
          >
            Garment List is Loading...
          </p>
        </div>
      ) : (
        <div className="flex flex-1 ">
          <div className="flex-1">
            {!loading && (
              <div className="flex-1">
                {qrMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => {
                            setSearchTermFocus(e.target.value);
                            handleScan({ data: e.target.value });
                          }}
                          placeholder="Scan QR Code"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {enabledRfIdModal && rfidMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => {
                            setSearchTermFocus(e.target.value);
                            handleScanRFID({ data: e.target.value });
                          }}
                          placeholder="Scan RFID Tag"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}
                {searchMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl">
                          {" "}
                        </InputIcon>
                        <InputText
                          placeholder="Search Invoice No."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                        />
                      </IconField>
                    </div>
                    {dataProviderSuggestion?.length > 0 && (
                      <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={handleSelectAllSearchedData}
                      >
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                          }
                          style={{ width: "50%" }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="flex-1 text-2xl font-medium text-center"
                    style={{ color: "green" }}
                  >
                    {alreadyPresentData}
                  </p>
                </div>
                {qrMethod || rfidMethod ? (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Scan Tag
                    </p>
                  </div>
                ) : dataProviderSuggestion?.length !== 0 ? (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>
                      <p className="flex-1 text-2xl font-medium">Store</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedTagItem()}
                    </div>
                  </div>
                ) : searchByInvoiceMethod ? (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Add Tag By Invoice
                    </p>
                  </div>
                ) : (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Search Tag
                    </p>
                  </div>
                )}

                {qrCodes?.length !== 0 && searchByInvoiceMethod && (
                  <div
                    style={{
                      pointerEvents:
                        isSendButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">
                        Invoice No.
                      </p>
                      <p className="flex-1 text-2xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedByInvoiceTagItem()}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className=" flex-1 surface-0"
            style={{
              "--surface-0": "#f2f2f2",
            }}
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Selected Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>
                      <p className="flex-1 text-2xl font-medium">Store</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "65vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div
                className="my-1 mx-2"
                style={{ pointerEvents: isSendButtonPressed ? "none" : "auto" }}
              >
                <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleSendToWarehouse}
                      disabled={isSendButtonPressed}
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed ? "Receiving..." : "Receive"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                          style={{ width: 30 }}
                        />
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceiveFromStore;
